import React from "react";
import { Crown } from "lucide-react";
import { ALBUM, TRACKLIST, STREAMING } from "../mock";
import { fbTrack } from "../lib/track";

const Music = () => {
  return (
    <section id="music" className="relative bg-[#0a0410] py-24 md:py-32 overflow-hidden">
      <div className="absolute top-1/3 -left-40 w-[500px] h-[500px] rounded-full bg-[#5b21b6]/20 blur-[130px]" />
      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#c9a24a] tracking-[0.3em] uppercase text-xs mb-3">The Album</p>
          <h2 className="heading-display gold-text text-4xl md:text-6xl">THE MUSIC</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Album cover */}
          <div className="relative group mx-auto md:mx-0 max-w-md w-full">
            <div className="absolute -inset-2 bg-gradient-to-tr from-[#d4af37]/40 via-[#7c3aed]/30 to-transparent rounded-lg blur-lg opacity-60 group-hover:opacity-90 transition-opacity duration-500" />
            <img
              src={ALBUM.cover}
              alt={ALBUM.title}
              className="relative w-full rounded-lg ring-1 ring-[#d4af37]/30 shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]"
            />
          </div>

          {/* Details */}
          <div>
            <p className="text-[#c9a24a] tracking-[0.25em] uppercase text-xs mb-2">Debut Album</p>
            <h3 className="heading-display text-white text-5xl md:text-6xl mb-5">{ALBUM.title}</h3>
            <p className="text-neutral-300 leading-relaxed mb-8">{ALBUM.description}</p>

            <div className="flex flex-wrap gap-3 mb-10">
              {STREAMING.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    fbTrack("ViewContent", {
                      content_name: `${ALBUM.title} on ${s.label}`,
                      content_category: "Music",
                      content_type: "product",
                    })
                  }
                  className="px-6 py-3 text-xs tracking-[0.15em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] rounded-sm hover:from-[#ffe38f] hover:to-[#d4af37] transition-all duration-300 hover:-translate-y-0.5"
                >
                  {s.label}
                </a>
              ))}
            </div>

            {/* Tracklist */}
            <div className="divide-y divide-white/10 border-t border-white/10">
              {TRACKLIST.map((t) => (
                <div
                  key={t.no}
                  className={`flex items-center gap-4 py-3.5 group transition-colors ${
                    t.lead ? "" : ""
                  }`}
                >
                  <span className="text-[#c9a24a]/70 text-sm w-7 font-medium">{t.no}</span>
                  <span
                    className={`flex-1 transition-colors ${
                      t.lead
                        ? "text-[#e8c65a] font-semibold"
                        : "text-neutral-200 group-hover:text-[#e8c65a]"
                    }`}
                  >
                    {t.title}
                  </span>
                  {t.lead && (
                    <span className="flex items-center gap-1.5 text-[10px] tracking-[0.15em] uppercase text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] px-2.5 py-1 rounded-full font-semibold">
                      <Crown size={12} /> Lead Single
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Music;
